import PropTypes from "prop-types";
import { Divider, Stack } from "@mui/material";

import { ResultItem } from "./result-item";

export const ResultList = ({ visibleResults, activeCategory, onResultClick }) => (
  <Stack
    divider={<Divider />}
    sx={{
      mt: 2,
      borderColor: "divider",
      borderRadius: 1,
      borderStyle: "solid",
      borderWidth: 1,
      overflow: "hidden",
    }}
  >
    {visibleResults.map((item) => (
      <ResultItem
        key={item.id}
        item={item}
        showCategory={!activeCategory || activeCategory === "Asset"}
        onResultClick={onResultClick}
      />
    ))}
  </Stack>
);

ResultList.propTypes = {
  visibleResults: PropTypes.array.isRequired,
  activeCategory: PropTypes.string,
  onResultClick: PropTypes.func.isRequired,
};